import { render, staticRenderFns } from "./pageBg.vue?vue&type=template&id=c28b7ace&scoped=true"
import script from "./pageBg.vue?vue&type=script&lang=js"
export * from "./pageBg.vue?vue&type=script&lang=js"
import style0 from "./pageBg.vue?vue&type=style&index=0&id=c28b7ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b7ace",
  null
  
)

export default component.exports